import { date } from 'quasar'

export default {
    data: function () {
        return {
            title: "Duplicate Check",
            loading: false,
            channelSettings: {
                ApplicationId: 0,
                SenderId: 0,
                SenderName: "",
                SenderCode: "",
                ReceiverId: 0,
                ReceiverName: "",
                ReceiverCode: ""
            },
            columns: [
                {
                    name: 'Id',
                    label: 'Id',
                    align: 'left',
                    field: row => row.Id,
                    sortable: false,
                    style: '',
                },
                {
                    name: 'SenderCode',
                    label: 'SenderCode',
                    align: 'left',
                    field: row => row.SenderCode,
                    sortable: false,
                    style: '',
                },
                {
                    name: 'ReceiverCode',
                    label: 'ReceiverCode',
                    align: 'left',
                    field: row => row.ReceiverCode,
                    sortable: false,
                    style: '',
                },
                {
                    name: 'ReceivedDocumentId',
                    label: 'ReceivedDocumentId',
                    align: 'left',
                    field: row => row.ReceivedDocumentId,
                    sortable: false,
                    style: '',
                },
                {
                    name: 'DocType',
                    label: 'Doc Type',
                    align: 'left',
                    field: row => row.DocType,
                    sortable: true,
                    style: '',
                },
                {
                    name: 'DocIdentifier',
                    label: 'Doc Identifier',
                    align: 'left',
                    field: row => row.DocIdentifier,
                    sortable: false,
                    style: '',
                },
                {
                    name: 'CreatedOn',
                    label: 'Created On',
                    align: 'left',
                    field: row => row.CreatedOn,
                    sortable: true,
                    style: '',
                    format: (val, row) => date.formatDate(val, 'MM/DD/YYYY hh:mm:ss A'),
                },
                {
                    name: 'Actions',
                    label: 'Actions',
                    align: 'center',
                    field: row => row.Actions,
                    sortable: false,
                    style: ''
                },
            ],
            columnsVisible: [
                'DocType', 'DocIdentifier', 'CreatedOn', 'Actions'
            ],
            dataSource: [],
            editRowKey: null,
            filter: null,
            pagination: {
                sortBy: 'CreatedOn',
                descending: true,
                page: 1,
                rowsPerPage: 15,
                rowsNumber: 0 // Need for 'QTable Request' event
            }
        }
    },

    methods: {
        onRequest(props) {
            this.onLoadListDataSource({
                page: props.pagination.page,
                pageSize: props.pagination.rowsPerPage,
                filter: props.filter,
                sortBy: props.pagination.sortBy,
                descending: props.pagination.descending
            });
        },

        refreshScreen() {
            if (this.channelSettings.ApplicationId > 0 && this.channelSettings.SenderId > 0 && this.channelSettings.ReceiverId > 0) {
                this.title = 'Duplicate Check - SENDER: ' +
                    this.channelSettings.SenderName +
                    ', RECEIVER: ' +
                    this.channelSettings.ReceiverName;

                this.pagination.page = 1;

                this.onRequest({
                    pagination: this.pagination,
                    filter: this.filter
                });
            } else {
                this.title = 'Duplicate Check';
                this.dataSource = [];
            }
        },

        async onExportActionClick() {
            try {
                this.loading = true;
                window.location.href = '/api/ui/duplicate_checks/' + this.channelSettings.SenderCode + '/' + this.channelSettings.ReceiverCode + '/export';
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },

        onDeleteActionClick(rowKey, rowIndex, row) {
            this.$q.dialog({
                title: 'Confirm',
                message: 'Are you sure?',
                cancel: true,
                persistent: true
            }).onOk(() => {
                if (this.onDeleteModelDataSource(rowKey, row)) {
                    var currentItemIndex = this.dataSource.map(e => { return e.Id; }).indexOf(rowKey);
                    this.dataSource.splice(currentItemIndex, 1);
                    this.pagination.rowsNumber = this.pagination.rowsNumber - 1;
                }
            });
        },

        async onLoadListDataSource(params) {
            try {
                this.loading = true;

                let startRow = (params.page - 1) * params.pageSize;
                let fetchCount = params.pageSize;

                let requestBody = {
                    Skip: startRow,
                    Take: fetchCount + 1,
                    Filter: params.filter,
                    OrderBy: params.sortBy ? params.sortBy : 'CreatedOn',
                    OrderByDescending: params.descending
                };

                let response = await this.$http.post('/api/ui/duplicate_checks/bySalesChannel/' + this.channelSettings.ApplicationId+ '/'+ this.channelSettings.SenderId + '/' + this.channelSettings.ReceiverId, requestBody);
                let listViewDataSource = response.body;

                this.dataSource.splice(0, this.dataSource.length, ...listViewDataSource.Rows);
                
                this.pagination.page = params.page;
                this.pagination.rowsPerPage = params.pageSize;
                this.pagination.sortBy = params.sortBy;
                this.pagination.descending = params.descending;

                if (listViewDataSource.TotalRows) {
                    this.pagination.rowsNumber = listViewDataSource.TotalRows;
                }
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },

        async onDeleteModelDataSource(id, params) {
            try {
                this.loading = true;

                let url = this.$prepareServerUrl('/api/ui/duplicate_checks/{id}', id, params);
                let response = await this.$http.delete(url);
                this.$processServerJsonResponse(response.body, this.refreshScreen);
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },
    },

    watch: {
        channelSettings: 'refreshScreen'
    }
}